<template>
    <div class="scanner-container">
        <div v-show="!isLoading" id="outerVideo">
            <video poster="data:image/gif,AAAA" id="scanner" ref="scanner" webkit-playsinline playsinline></video>
            <div class="overlay-element"></div>
            <div class="laser"></div>
        </div>
    </div>
</template>

<script>
import { BrowserMultiFormatReader, Exception } from "@zxing/library";
export default {
    name: "stream-barcode-reader",
    data() {
        return {
            isLoading: true,
            codeReader: new BrowserMultiFormatReader(),
            isMediaStreamAPISupported:
                navigator &&
                navigator.mediaDevices &&
                "enumerateDevices" in navigator.mediaDevices
        };
    },
    mounted() {
        if (!this.isMediaStreamAPISupported) {
            throw new Exception("Media Stream API is not supported");
        }
        this.start();
        this.$refs.scanner.oncanplay = event => {
            console.log(event);
            this.isLoading = false;
            this.$emit("loaded");
        };
    },
    beforeUnmount() {
        this.codeReader.reset();
    },
    methods: {
        start() {
            //this.codeReader.reset();
            var constraints = {
                video: {
                    facingMode: 'environment',
                    focusMode: 'continuous',
                    frameRate: { ideal: 25, max: 30 },
                    width: { min: 1024, ideal: 2048, max: 4048 },
                },
                audio: false,
            };
            this.codeReader.decodeFromConstraints(
                constraints,
                this.$refs.scanner,
                (result, err) => {
                    console.log(err);
                    if (result) {
                        this.$emit("decode", result.text);
                    }
                }
            );
/*             this.codeReader.decodeFromVideoDevice(
                undefined,
                this.$refs.scanner,
                (result, err) => {
                    console.log(err);
                    if (result) {
                        this.$emit("decode", result.text);
                    }
                }
            ); */
        }
    }
};
</script>

<style scoped>


.scanner-container {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
}
video#scanner {
    max-width: 100%; 
    width: 100% !important;
    
}

/* .scanner-container {
    position: relative;
    height: var(--video-height);
} */
.overlay-element {
    position: absolute;
    top: 0;
    width: 100%;
    height: 99%;
    background: rgba(30, 30, 30, 0.5);
    -webkit-clip-path: polygon(
        0% 0%,
        0% 100%,
        20% 100%,
        20% 20%,
        80% 20%,
        80% 80%,
        20% 80%,
        20% 100%,
        100% 100%,
        100% 0%
    );
    clip-path: polygon(
        0% 0%,
        0% 100%,
        20% 100%,
        20% 20%,
        80% 20%,
        80% 80%,
        20% 80%,
        20% 100%,
        100% 100%,
        100% 0%
    );
}
.laser {
    width: 60%;
    margin-left: 20%;
    background-color: tomato;
    height: 1px;
    position: absolute;
    top: 30%;
    z-index: 2;
    box-shadow: 0 0 4px red;
    -webkit-animation: scanning 2s infinite;
    animation: scanning 2s infinite;
}
@-webkit-keyframes scanning {
    60% {
        -webkit-transform: translateY(80px);
        transform: translateY(80px);
    }
}
@keyframes scanning {
    60% {
        -webkit-transform: translateY(80px);
        transform: translateY(80px);
    }
}


</style>